import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import { resetProductArena } from '../../../reducers/productArenaReducer';
import ProductArenaForm from './productArenaForm';

interface IAddProductArenaProps {
    classes: any;
    theme: Theme;
    match: any;
    steps: Array<number>;
    productArenaId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetProductArena: () => dispatch(resetProductArena())
});

const mapStoreToProps = (store: RootState, ownProps: IAddProductArenaProps) => {
    return {
        productArenaId: ownProps.match.params?.productArenaId ? Number(ownProps.match.params?.productArenaId) : undefined
    };
};

class AddProductArena extends Component<IAddProductArenaProps> {
    componentWillUnmount() {
        resetProductArena();
    }

    render() {
        const { classes, steps, productArenaId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <ProductArenaForm productArenaId={productArenaId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddProductArena));